/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 更换手机号
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  phone: member.PhoneUpdateInfoDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/member/setting/phone`,
    data: phone,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
